import React from "react";

class ApplyLiveChatClass extends React.Component {
    componentDidMount(){
        this.interval = setInterval(()=> {
            const chatDiv = document.querySelector('.LPMcontainer');
            if(chatDiv && sessionStorage && sessionStorage?.getItem('isStreamline') === "true" && !chatDiv.classList.contains('streamlineChat')){
                chatDiv.classList.add('streamlineChat');
            }
        },1000)
    }
    componentWillUnmount(){
        clearInterval(this.interval);
    }
    render(){
        return null;
    }
}
export default ApplyLiveChatClass